import { Order } from './Order.enum';
import { StudentInterface } from './Student.interface';

export interface StudyRequestInterface {
	id?: string;
	name?: string;
	email?: string;
	phone?: string;
	unit?: string;
	description?: string;
	students?: StudentInterface[];
	requestAttachments?: any[];
	submitDate?: string;
	status?: StudyRequestStatus;
	notes?: string;
	attachmentsToDelete?: any[];
	isMilitary?: boolean;
	basicFlowEmail?: string;
	isSendEmail?: boolean;
	dublicateCount?: string|null;
	agreement?: boolean;
}

export enum StudyRequestStatus {
	PENDING = 'pending',
	APPROVED = 'approved',
	REJECTED = 'rejected',
}

export interface StudyRequestFilter {
	status?: StudyRequestStatus;
	submitDateStart?: string;
	submitDateEnd?: string;
	email?: string;
	phone?: string;
	unit?: string;
	orderBy?: StatusRequestOrderBy;
	order?: Order;
	withRelations?: boolean;
	page?: number;
	limit?: number;
	[key: string]: any;
}
export enum StatusRequestOrderBy {
	EMAIL = 'email',
	UNIT = 'unit',
	NAME = 'name',
	SUBMIT_DATE = 'submitDate',
	PHONE = 'phone',
	STATUS = 'status',
}
